<template>
    <div
    v-touch:swipe.left="hasExternalSwipe ? null : swipeLeft"
    v-touch:swipe.right="hasExternalSwipe ? null : swipeRight"
    class="carrocel-slider-content-wrapper">
        <div ref="sliderRef" class="carrocel-slider-wrapper">
            <div
            v-for="(item, index) in sliderList"
            class="item"
            :key="`itemList${index}`"
            :class="{ 'selected': index === selectedIndex }">
                <div class="item-content" :style="{ 'background-image': `url(${item.imageUrl})`}"/>
            </div>
        </div>
        <!-- Circles to visually see our position in slider -->
        <navigation-circles-wrapper
        v-if="selectedIndex.length > 1"
        :listLength="sliderList.length"
        :selectedIndex="internalSelectedIndex"/>
    </div>
</template>

<script setup>
import NavigationCirclesWrapper from '@/components/generic/sliders/navigation/CirclesWrapper.vue'

/* Vue & Aux */
import { ref, watch } from 'vue'
import { scrollTo } from '@/assets/scripts/scrollAnimation'

const emit = defineEmits(['updateSelectedIndex'])

/* Props
@selectedIndex { Number }
@sliderList { Array } - in which object with card info, needs to have:
	- title { String }
	- shortDescription { String }
@hasExternalSwipe {Boolean} to prevent swiptFunction from being trigger, when parent component has full swipe on it, preving index from changing twice
*/
const props = defineProps({
    selectedIndex: Number,
    sliderList: Array,
    hasExternalSwipe: Boolean,
    hasCustomItem: Boolean
})

const sliderRef = ref('')
const internalSelectedIndex = ref(props.selectedIndex || 0)

watch(() => props.selectedIndex, (newVal, oldVal) => {
    if (newVal === oldVal) return

    internalSelectedIndex.value = newVal
    if (newVal > oldVal) moveLeft()
    else if (newVal < oldVal) moveRight()
})

/*************************************************
 *                                                *
 *                Swipe/Move Handlers             *
 *                                                *
 *************************************************/
const swipeLeft = () => {
    if (internalSelectedIndex.value === (props.sliderList.length - 1)) return
    internalSelectedIndex.value++
    moveLeft()
}

const swipeRight = () => {
    if (internalSelectedIndex.value === 0) return
    internalSelectedIndex.value--
    moveRight()
}

const moveLeft = () => {
    const newScrollPosition = ((214 + 8 /* gap */) * internalSelectedIndex.value)
    emit('updateSelectedIndex', internalSelectedIndex.value)
    scrollTo(sliderRef.value, newScrollPosition, null, 700, 'horizontal')
}

const moveRight = () => {
    const newScrollPosition = ((214 + 8 /* gap */) * internalSelectedIndex.value)
    emit('updateSelectedIndex', internalSelectedIndex.value)
    scrollTo(sliderRef.value, newScrollPosition, null, 700, 'horizontal')
}
</script>

<style lang="scss" scoped>
.carrocel-slider-content-wrapper {
    width: 100%;
    height: 172px;

    position: relative;

    .carrocel-slider-wrapper {
        width: 100%;
        height: 100%;
        padding: 0 calc((100% - 240px) / 2) 24px calc((100% - 240px) / 2);

        display: flex;
        align-items: center;
        gap: 8px;
        overflow: hidden;

        .item {
            width: 214px;
            height: 128px;
            flex-shrink: 0;

            opacity: 0.24;
            border-radius: 8px;

            transition: all 0.7s linear;

            .item-content {
                width: 100%;
                height: 100%;

                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;

                border-radius: 8px;

                transform: scale(1);
                transition: all 0.5s linear;
                z-index: 1;
                overflow: hidden;
            }

            &.selected {
                width: 240px;
                height: 144px;
                opacity: 1;
                z-index: 2;

                .item-content {
                    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.25);
                }
            }
        }
    }
}
</style>
